/* global __webpack_public_path__:writable */

import 'utils/googleTranslateFix';

try {
	__webpack_public_path__ = window.__BASE_URL__;
} catch (e) {}

import { h, render } from 'preact';

import UniversalHubApp from 'base/universalHub/universalHubApp';

if (window.parent !== window && new URLSearchParams(location.search).has('cms-preview')) {
	// Third-party cookies cannot be set in iframes, which prevents onetrust from closing properly
	// In this case, we replace the native cookies by our own basic implementation to make it work in the CMS preview
	import('utils/fakeCookies').then(({ fakeCookies }) => fakeCookies());
}

let elem = document.getElementById('app');
if (!elem) {
	elem = document.createElement('div');
	elem.id = 'app';
	document.body.appendChild(elem);
}
render(<UniversalHubApp initialStore={window.__INITIAL_STATE__} />, elem, elem.firstChild);
